import Plugin from '../core/Plugin';

/**
 * HistoryPlugin - Handles undo/redo functionality
 */
class HistoryPlugin extends Plugin {
  constructor(editor, options = {}) {
    super(editor, options);
    this.name = 'History';
  }

  getToolbarButtons() {
    return [
      {
        name: 'history',
        buttons: [
          { command: 'undo', label: '<i class="fa-solid fa-rotate-left"></i>', title: 'Undo' },
          { command: 'redo', label: '<i class="fa-solid fa-rotate-right"></i>', title: 'Redo' },
        ],
      },
    ];
  }

  executeCommand(command) {
    switch (command) {
      case 'undo':
        this.editor.undo();
        break;
      case 'redo':
        this.editor.redo();
        break;
    }
  }

  handleKeyboard(event) {
    const cmdKey = event.ctrlKey || event.metaKey;

    if (cmdKey && event.key === 'z' && !event.shiftKey) {
      event.preventDefault();
      this.executeCommand('undo');
      return true;
    } else if ((cmdKey && event.key === 'z' && event.shiftKey) || (cmdKey && event.key === 'y')) {
      event.preventDefault();
      this.executeCommand('redo');
      return true;
    }
    return false;
  }

  getMetadata() {
    return {
      name: 'History',
      version: '1.0.0',
      description: 'Provides undo/redo functionality with keyboard shortcuts',
      author: 'AtlaraFirm',
    };
  }
}

export default HistoryPlugin;
